import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../ActionReports/hooks/useIsMobile";
import KpiRawDataCards from "../KpiRawDataCards/KpiRawDataCards";
import KpiRawDataTable from "../KpiRawDataTable/KpiRawDataTable";
import { KpiSeries } from "../types";
import defaultContent from "../../../../content/keyMetrics";
import downlineProfileContent from "../../../../content/downlineProfile";
import { useEffect, useState } from "react";
import { getLongPeriodFormat, getPerformanceYear } from "../../../../common/util/period";
import LeafRectangleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import { ErrorTile } from "../ErrorTile/ErrorTile";
import { LeafErrorMessage } from "../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import { IconNoData } from "../../../../common/icons/IconNoData/IconNoData";
import { getSeriesPYs } from "../utils";
import { trackSelectPerformanceYear } from "../../PlatinumProfile/downlineProfileTealium";
interface RawDataViewProps {
  series?: KpiSeries[] | null;
  selectedKpis?: string[];
  selectedPerformanceYear?: number;
  locale?: string;
  endPeriod?: number;
  startPeriod?: number;
  isLoading?: boolean;
  isError?: boolean;
  retry?: () => {};
}
const RawDataView = (props: RawDataViewProps) => {
  const { t } = useTranslation(["keyMetrics", "downlineProfile"]);
  const isMobile = useIsMobile();
  const [selectedPY, setSelectedPY] = useState<number>(Number(getPerformanceYear(props.endPeriod ?? "")));

  const selectablePYs = getSeriesPYs(props.series);

  const filteredSeries = props?.series?.filter((s) => s?.years !== null);

  useEffect(() => {
    if (props.endPeriod) {
      setSelectedPY(Number(getPerformanceYear(props.endPeriod)));
    }
  }, [props.endPeriod]);
  if (props?.isError) {
    return (
      <div className="table-view-error">
        <ErrorTile
          tealiumTrackId="trendTable"
          errorStatus={props?.isError ?? false}
          clickFunction={props.retry ?? (() => {})}
          isLoading={props?.isLoading ?? false}
        />
      </div>
    );
  }

  if ((!filteredSeries || filteredSeries.length === 0) && !props.isLoading) {
    return (
      <div data-testid="trend-chart-empty">
        <LeafErrorMessage
          show={true}
          icon={<IconNoData height="12.5rem" width="15.66rem" />}
          headline={t("trendChart.emptyMessage", downlineProfileContent.trendChart.emptyMessage) as string}
          fontSize="big"
          gap={true}
          noContent={true}
        />
      </div>
    );
  }

  return (
    <>
      {props.isLoading ? (
        <div className="table-view-selector">
          <div>
            {Array.from({ length: 3 }).map((_, i) => (
              <LeafRectangleLoader key={i} isLoading width="3rem" height="1.5rem" />
            ))}
          </div>
          <LeafRectangleLoader isLoading width="15rem" height="1.5rem" />
        </div>
      ) : (
        <div className="table-view-selector">
          <div>
            {[...selectablePYs].map((year) => {
              const isSelected = year === selectedPY;
              return (
                <button
                  key={year}
                  onClick={() => {
                    setSelectedPY(year);
                    trackSelectPerformanceYear(year);
                  }}
                  className={isSelected ? "table-view-selector--selected" : ""}
                >
                  <p>{`${t("pyYear", defaultContent.pyYear, { ns: "keyMetrics" })}${year % 100}`}</p>
                  {isSelected && <div></div>}
                </button>
              );
            })}
          </div>
          <p>{`${t(`performanceMetrics.lastProcessedMonth`, downlineProfileContent.performanceMetrics.lastProcessedMonth, { ns: "downlineProfile", date: getLongPeriodFormat(props.endPeriod ?? "", props?.locale ?? "") })}`}</p>
        </div>
      )}
      {isMobile ? (
        <KpiRawDataCards {...props} series={filteredSeries} selectedPerformanceYear={selectedPY} />
      ) : (
        <KpiRawDataTable {...props} series={filteredSeries} selectedPerformanceYear={selectedPY} />
      )}
    </>
  );
};

export default RawDataView;
